import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useDeckSession } from "../hooks/useDeckSession";
import { useCanvasFirebase } from "../hooks/useCanvasFirebase";
import CanvasDisplay from "../bigComponents/canvasDisplay";

export default function AudienceView() {
  const { deckId } = useParams();
  const { currentSlideId, adminScrollY } = useDeckSession(deckId);
  const { elements, loading } = useCanvasFirebase(currentSlideId, false);
  const scrollContainer = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      // Logic: If the screen is wider than 768px, we treat it as desktop
      // and scale based on our "iPhone" frame width (390px).
      const isDesktop = window.innerWidth > 440;
      const baseWidth = 360;//isDesktop ? 390 : 360; 
      const newScale = window.innerWidth / baseWidth;
      
      // On desktop, we usually don't want to scale up past 1 
      // because we want the "phone in the middle" effect.
      setScale(isDesktop ? 1 : newScale);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!scrollContainer.current) return;
    const animationFrame = requestAnimationFrame(() => {
      if (scrollContainer.current) {
        scrollContainer.current.scrollTo({
          top: adminScrollY,
          behavior: "auto" 
        });
      }
    });
    return () => cancelAnimationFrame(animationFrame);
  }, [adminScrollY]);

  if (!deckId) return <div style={msgStyle}>No Deck ID provided.</div>;
  if (loading) return <div style={msgStyle}>Connecting...</div>;

  return (
    <div style={lockdownContainer}>
      <div style={{ ...scalerStyle, transform: `scale(${scale})` }}>
        <div ref={scrollContainer} style={audienceCanvasFrame}>
          <CanvasDisplay
            elements={elements}
            isEditable={false}
          />
        </div>
      </div>
    </div>
  );
}

// --- Styles ---

const lockdownContainer = { 
  width: "100vw", 
  height: "100vh", 
  background: "#111", 
  display: "flex", 
  justifyContent: "center",
  alignItems: "center", // Vertically centers the "phone" on desktop
  overflow: "hidden",
  position: "fixed" 
};

const scalerStyle = {
  width: "100%",
  maxWidth: "390px", // iPhone 12 Width
  height: "100%",
  maxHeight: "844px", // iPhone 12 Height
  display: "flex",
  justifyContent: "center",
  transformOrigin: "center center",
  boxShadow: window.innerWidth > 768 ? "0 0 50px rgba(0,0,0,0.5)" : "none",
  borderRadius: window.innerWidth > 768 ? "30px" : "0px", // Rounded corners on desktop
  overflow: "hidden",
  border: window.innerWidth > 768 ? "8px solid #333" : "none" // Slight bezel
};

const audienceCanvasFrame = { 
  width: "100%", 
  height: "100%", 
  overflowY: "hidden", 
  background: "#fff", 
  position: 'relative',
  willChange: "transform" 
};

const msgStyle = { color: "white", textAlign: "center", paddingTop: "50px" };